"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "EbiSpeciesIconBare", {
  enumerable: true,
  get: function get() {
    return _EbiSpeciesIconBare["default"];
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _EbiSpeciesIcon["default"];
  }
});
exports.renderBare = exports.render = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _EbiSpeciesIcon = _interopRequireDefault(require("./EbiSpeciesIcon"));
var _EbiSpeciesIconBare = _interopRequireDefault(require("./EbiSpeciesIconBare"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var render = exports.render = function render(options, target) {
  _reactDom["default"].render(/*#__PURE__*/_react["default"].createElement(_EbiSpeciesIcon["default"], options), document.getElementById(target));
};
var renderBare = exports.renderBare = function renderBare(options, target) {
  _reactDom["default"].render(/*#__PURE__*/_react["default"].createElement(_EbiSpeciesIconBare["default"], options), document.getElementById(target));
};